import { useRef, useMemo, useEffect } from 'react';
import Plyr from "plyr-react";
import "plyr-react/plyr.css";


function VideoBlock({ video, onView }) {

  const ref = useRef();
  const viewed = useRef(false);

  useEffect(() => {
    if (!onView) return;
    const handlePlay = () => {
      if (!viewed.current) {
        viewed.current = true;
        onView();
      }
    };

    let timer;
    let attachedPlyr = null;

    const tryAttach = () => {
      const plyr = ref.current?.plyr;
      if (typeof plyr?.on === 'function') {
        plyr.on('play', handlePlay);
        attachedPlyr = plyr;
      } else {
        timer = setTimeout(tryAttach, 100);
      }
    };

    timer = setTimeout(tryAttach, 0);

    return () => {
      clearTimeout(timer);
      if (attachedPlyr && typeof attachedPlyr.off === 'function') {
        attachedPlyr.off('play', handlePlay);
      }
    };
  }, [onView]);

  const source = useMemo(() => {
    const result = {
      type: "video",
      sources: [],
      tracks: [],
    };

    for (let size of video.sizes) {
      result.sources.push({
        src: size.video_file,
        size: size.quality.slice(0, -1),
        type: "video/mp4"
      });
    }
    if (video.subtitles_file) {
      result.tracks.push({
        src: video.subtitles_file,
        kind: "subtitles",
        srclang: "uk",
        label: "Ukranian",
        default: true
      })
    }
    if (video.preview_file) {
      result.poster = video.preview_file;
    }
    return result
  }, [video]);

  if ( ! source.sources.length) {
    return (
      <h2>Not video</h2>
    );
  }

  return (
    <Plyr ref={ref} source={source} crossOrigin="anonymus" />
  );
}

export default VideoBlock;
